<div class="flex flex-1 flex-col gap-2">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="1"
  >
    <dxi-item itemType="group" [colCount]="2">
      <dxi-item
        dataField="title"
        [editorOptions]="{ placeholder: 'Titolo' | transloco }"
        [label]="{ visible: false }"
      ></dxi-item>

      <dxi-item
        dataField="category"
        [label]="{ visible: false }"
        [editorOptions]="{ placeholder: 'Categoria' | transloco }"
      ></dxi-item>
    </dxi-item>
  </dx-form>
</div>
